import { render } from "./referralModal.vue?vue&type=template&id=001c966c&scoped=true&ts=true"
import script from "./referralModal.vue?vue&type=script&lang=ts"
export * from "./referralModal.vue?vue&type=script&lang=ts"

import "./referralModal.vue?vue&type=style&index=0&id=001c966c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001c966c"]])

export default __exports__